<template>
  <va-form :id="id" :item="item">
    <v-row justify="center">
      <v-col sm="6">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2">
              {{ title }}
            </div>
          </template>
          <v-card-text>
            <va-text-input source="mws_configuration_id"></va-text-input>
            <va-text-input source="parent_id"></va-text-input>
            <va-text-input source="name"></va-text-input>
            <va-text-input source="asin"></va-text-input>
            <va-text-input source="sku"></va-text-input>
            <va-text-input source="fn_sku"></va-text-input>
            <va-text-input source="qty"></va-text-input>
            <va-text-input source="row_total"></va-text-input>
          </v-card-text>
          <va-save-button></va-save-button>
        </base-material-card>
      </v-col>
    </v-row>
  </va-form>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
